
import Login from "../../../assets/outline/Login.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LoginIcon({ className, dataTestid = "LoginIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Login data-testid={dataTestid} className={classes} {...rest} />
  );
}
